import {types} from "../actions/types";
import {mergeObjects} from "../_helpers/materialTheme";

export const initialStateMaterialDarkTheme = {
    overrides: {
        MuiCssBaseline: {
            "@global": {
                html: {WebkitFontSmoothing: 'auto'},
                a: {color: "#fff"}
            }
        },
        MuiButton: {
            root: {
                height: '48px',
                borderRadius: '16px'
            }
        },
        MuiSkeleton: {
            root: {backgroundColor: '#2F2F2F'}
        }
    },
    palette: {
        type: 'dark',
        primary: {
            main: '#EA0027',
            contrastText: '#fff'
        },
        secondary: {
            main: "rgba(255,255,255,.2)",
            contrastText: '#ffffff'
        },
        background: {
            default: '#000000',
            paper: '#21222b'
        },
        error: {
            light: '#FDEDED',
            main: '#d32f2f',
            dark: '#c62828',
        },
        warning: {
            light: '#FFF4E5',
            main: '#ed6c02',
            dark: '#e65100',
        },
        info: {
            light: '#E5F6FD',
            main: '#0288d1',
            dark: '#01579b',
        },
        headerBar: {
            home: '#000000',
            homeText: '#ffffff',
            transparent: 'transparent',
            signUp: 'black',
            signUpBack: 'white'
        },
        icons: {profile: '#fff'},
        error404: {code: '#202020'},
        nutrition: {
            tab: {
                default: 'transparent',
                defaultTextColor: 'white',
                selectedBackground: 'white',
                selectedTextColor: 'black',
                borderColor: 'white'
            }
        },
        notification: {
            background: 'white',
            contrastText: 'black',
            border: 'white',
            icon: 'black',
        }
    },
    typography: {
        allVariants: {color: '#fff'},
        banner: {color: '#fff'},
        root: {color: '#fff'},
        fontFamily: 'Raleway,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
    },
};



export const materialUIDarkThemeReducer = (state = initialStateMaterialDarkTheme, action) => {
    switch (action?.type) {
        case types.updateMaterialUIDarkTheme:
            return {...state, ...mergeObjects(initialStateMaterialDarkTheme, action.payload)};
        case types.restartMaterialUIDarkTheme:
            return initialStateMaterialDarkTheme
        default:
            return state;
    }
};
